import type { Primitive } from 'type-fest';

export const dedupe = <T extends Primitive>(s: T[]) => Array.from(new Set(s));
